"use client"

import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import { User, Sun, Moon, X } from "lucide-react";
import carLogo from "../Image/logocar-CN7UAsq-.png";
import { BounceLoader } from "react-spinners";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [isArabic, setIsArabic] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // حالة تسجيل الدخول

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDarkMode = () => setDarkMode(!darkMode);
  const toggleLanguage = () => setIsArabic(!isArabic);

  const navigate = useNavigate();
  const location = useLocation();

  // أي صفحة محتاجة لودنج
  const pagesWithLoading = ["/", "/about", "/services", "/cars", "/contact"];

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  useEffect(() => {
    if (pagesWithLoading.includes(location.pathname)) {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  // التحقق من وجود التوكن عند تحميل Navbar
  useEffect(() => {
    const token = localStorage.getItem("userToken");
    setIsLoggedIn(!!token);
  }, []);

  const handleLoginClick = () => {
    navigate("/login");
    setMenuOpen(false);
  };

  const handleLogoutClick = () => {
    localStorage.removeItem("userToken"); // مسح التوكن
    setIsLoggedIn(false);
    navigate("/login");
    setMenuOpen(false);
  };

  return (
    <>
      {loading && (
        <div className={styles.loadingOverlay}>
          <BounceLoader color="#ff4d30" size={60} />
        </div>
      )}

      <nav className={`${styles.navbar} ${darkMode ? styles.darkNavbar : ""}`}>
        <div className={styles.container}>
          {/* Logo */}
          <div className={styles.logo}>
            <div className={styles.logoContainer}>
              <img src={carLogo} alt="KARZONE Car Logo" width={60} height={20} className={styles.carLogo} />
              <span className={styles.logoText}>KARZONE</span>
            </div>
          </div>

          {/* Navigation Links */}
          <div className={`${styles.navLinks} ${menuOpen ? styles.showMenu : ""}`}>
            <div className={styles.mobileMenuHeader}>
              <button onClick={toggleMenu} className={styles.closeButton}>
                <X size={24} />
              </button>
            </div>

            <Link to="/" className={`${styles.navLink}`} onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/about" className={styles.navLink} onClick={() => setMenuOpen(false)}>About</Link>
            <Link to="/services" className={styles.navLink} onClick={() => setMenuOpen(false)}>Services</Link>
            <Link to="/cars" className={styles.navLink} onClick={() => setMenuOpen(false)}>Cars</Link>
            <Link to="/contact" className={styles.navLink} onClick={() => setMenuOpen(false)}>Contact</Link>

            <div className={styles.mobileIcons}>
              {isLoggedIn ? (
                <button className={`${styles.mobileLoginButton} ${darkMode ? styles.darkButton : ""}`} onClick={handleLogoutClick}>
                  <User size={18} />
                  <span>Logout</span>
                </button>
              ) : (
                <button className={`${styles.mobileLoginButton} ${darkMode ? styles.darkButton : ""}`} onClick={handleLoginClick}>
                  <User size={18} />
                  <span>Login</span>
                </button>
              )}

              {/* <button onClick={toggleLanguage} className={styles.mobileLanguageToggle}>
                {isArabic ? "ع" : "E"}
              </button>
              <button onClick={toggleDarkMode} className={styles.mobileDarkModeToggle}>
                {darkMode ? <Sun size={20} /> : <Moon size={20} />}
              </button> */}
            </div>
          </div>

          {/* Hamburger Menu */}
          <div className={styles.hamburger} onClick={toggleMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>

          {/* Desktop Login / Language Toggle */}
          <div className={styles.loginSection}>
            {isLoggedIn ? (
              <button className={`${styles.loginButton} ${darkMode ? styles.darkButton : ""}`} onClick={handleLogoutClick}>
                <User size={18} />
                <span>Logout</span>
              </button>
            ) : (
              <button className={`${styles.loginButton} ${darkMode ? styles.darkButton : ""}`} onClick={handleLoginClick}>
                <User size={18} />
                <span>Login</span>
              </button>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
